import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-iframe-form',
  templateUrl: './iframe-form.component.html',
  styleUrls: ['./iframe-form.component.css']
})
export class UrlFormComponent implements OnInit {

  @Input("form") form: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/iframe-form/iframe-form.component.ts